import { Vue, i18n } from 'Common/vue';

import "../layouts/shopping"
import "./shopping-jquery"
import "../components/smartform"

import '../ui/toggle';

const cartVouchersEl = document.getElementById('cart-vouchers')

if (cartVouchersEl) {
    cartVouchersEl.addEventListener('rToggle.afterOpen', event => {
        event.currentTarget.querySelector('input[name="voucher"]').focus()
    })
}

rEvent.on('Cart.product.updated', function () {
    location.reload();
});

if (document.querySelector('#sps-parcelshop-map-pickup-el')) {
    import('../components/vue/SpsParcelshopPickupMap.vue').then((module) => {
        window.$_spsParcelshopPickupMap = new Vue({
            i18n,
            render: h => h(module.default)
        }).$mount("#sps-parcelshop-map-pickup-el");
    })
}